import { Box, Divider, Stack, Text, VStack } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { ContextAuth } from '../../../../../contexts/Authentication';
import { INewResourceProps } from '../../../../../services/hooks/Resources/useGetRequestNewResource';
import LabelWithValueMobilePage from '../../../../../components/Mobile/labelWithValue';

interface IOwnProps {
  data?: INewResourceProps;
  selectiveProcess?: string;
  isImpugnation: boolean;
}

const InformationCardCreateResource: React.FC<IOwnProps> = ({ data, selectiveProcess, isImpugnation }) => {
  const { candidate } = useContext(ContextAuth);

  return (
    <Box bg="#f8f8f8b0" p={4} rounded="lg" shadow="md">
      <VStack align="center" spacing={3}>
        <Text fontWeight="semibold" fontSize="md">
          Dados da inscrição
        </Text>
        <Divider borderColor="gray" />
        <Stack spacing={2} w="100%">
          {data?.registration?.registration_code && (
            <LabelWithValueMobilePage label="Inscrição" value={data?.registration.registration_code.toString()} />
          )}
          <LabelWithValueMobilePage label="Candidato" value={candidate?.user?.full_name} />
          <LabelWithValueMobilePage
            label="Recurso"
            value={isImpugnation ? 'Impugnação contra os termos do edital' : data?.period_identification || '--'}
          />

          {data?.resource_period && <LabelWithValueMobilePage label="Período" value={data?.resource_period} />}
          <LabelWithValueMobilePage label="Processo Seletivo" value={selectiveProcess} />
          {data?.vacancy?.name && (
            <LabelWithValueMobilePage label={data.is_culture_house ? 'Turma' : 'Vaga'} value={data?.vacancy.name} />
          )}
        </Stack>
      </VStack>
    </Box>
  );
};

export default InformationCardCreateResource;
